import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getApiDataService } from "../../../services/apiServices";
import { APP_GUIDE_API } from "../../../services/CONSTANTS";

function CreateAppGuide(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const [accountName, setAccountName] = useState(null);
  const [accountNo, setAccountNo] = useState(null);

  const [isLoading, setIsLoading] = useState(props.isLoading);
  const [thumbnail, setThumbnail] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleLogoChange = (e) => {
    // setLogo(event.target.value);
    if (
      e.target.files[0].type === "image/jpeg" ||
      e.target.files[0].type === "image/png" ||
      e.target.files[0].type === "image/jpg"
    ) {
      let imgReview = e.target.files[0];
      console.log(imgReview);
      if (imgReview) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result);
        };
        reader.readAsDataURL(imgReview);
      } else {
        setPreview(null);
      }
      setThumbnail(e.target.files[0]);
    } else {
      alert("This is only accept image files! Thanks");
      setThumbnail(null);
      return;
    }
  };
  // Handler functions for updating account information
  const handleAccountNameChange = (event) => {
    setAccountName(event.target.value);
  };

  const handleAccountNoChange = (event) => {
    setAccountNo(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let data = {
      title: accountName,
      streaming_url: accountNo,
      thumbnail: thumbnail,
    };
    props.onSubmit(data);
  };

  return (
    <Modal isOpen={true}  toggle={props.onClose}>
      <ModalHeader  toggle={props.onClose}>Create App Guide </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="title">Title</Label>
            <Input type="text" name="title" id="title" onChange={handleAccountNameChange} />
          </FormGroup>
          <FormGroup>
            <Label for="description">URL</Label>
            <Input
              type="text"
              name="description"
              id="description"
              onChange={handleAccountNoChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="logo">Logo</Label>
            <Input
              type="file"
              accept="image/png, image/gif, image/jpeg"
              name="logo"
              id="logo"
              onChange={handleLogoChange}
            />
          </FormGroup>
          {preview && <img src={preview} alt="" style={{ width: "100px", height: "100px" }} />}
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default CreateAppGuide;
